export default __webpack_public_path__ + "static/media/PromoCard.0b8cc13a.webp";